import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Index";
import Profile from "@/components/Profile";
import About from "@/components/About";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    {
      path: "/profile/:providerName",
      name: "Profile",
      component: Profile
    },
    {
      path: "/about",
      name: "About",
      component: About
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js